var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "book" }, [
    _c("div", { staticClass: "book__banner" }, [
      _c("div", { staticClass: "book__banner__textPic" }),
      _vm.isSale
        ? _c(
            "div",
            { staticClass: "book__banner__mobilePreorder hidden-mobile-up" },
            _vm._l(_vm.mobilePreorderText, function(char, index) {
              return _c(
                "span",
                {
                  key: index,
                  staticClass: "wave-char",
                  style: {
                    animationDelay:
                      index * (1.0 / _vm.mobilePreorderText.length) + "s"
                  }
                },
                [_vm._v("\n        " + _vm._s(char) + "\n      ")]
              )
            }),
            0
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "book__main" }, [
      _c("h1", { staticClass: "hidden-mobile-up hidden-mobile-down" }, [
        _vm._v("2024 解答之书")
      ]),
      _vm._m(0),
      _c("div", { staticClass: "book__main__constellations" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "book__main__constellations__list" },
          _vm._l(_vm.book2024_list, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "book__main__constellations__list__item",
                on: {
                  click: function($event) {
                    return _vm.toBuyOrRead(item)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "book__main__constellations__list__item__pic",
                    class: "background-" + ((index % 3) + 1)
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: item.bookImg,
                        alt: "解答之書-" + item.cn + "座圖片"
                      }
                    })
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "book__main__constellations__list__item__title"
                  },
                  [
                    _c("img", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !item.isUnlock,
                          expression: "!item.isUnlock"
                        }
                      ],
                      attrs: {
                        src: require("../../assets/運勢書共用/icon-locked.svg"),
                        alt: "解答之書-需要解鎖"
                      }
                    }),
                    _vm._v(
                      "\n            " + _vm._s(item.cn) + "座\n          "
                    )
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    ]),
    _vm.needAnimation
      ? _c(
          "div",
          {
            staticClass: "book__animation",
            class: { "fade-out": !_vm.showAnimation }
          },
          [
            _c("div", { staticClass: "book__animation__video" }, [
              _c(
                "video",
                {
                  ref: "video",
                  attrs: {
                    muted: "",
                    playsinline: "true",
                    "webkit-playsinline": "true"
                  },
                  domProps: { muted: true },
                  on: { loadedmetadata: _vm.handleVideoLoaded }
                },
                [
                  _c("source", {
                    attrs: {
                      src: require("../../assets/運勢書共用/taiwanNo1.mp4"),
                      type: "video/mp4"
                    }
                  }),
                  _vm._v(
                    "\n        很抱歉，您的浏览器似乎不支援 HTML5 的 video\n        标签。为了获得最佳的观看体验，请考虑切换到一个支援 HTML5 video\n        的浏览器。\n      "
                  )
                ]
              )
            ]),
            _c(
              "div",
              {
                staticClass: "book__animation__loading",
                class: { "fade-out": !_vm.isLoading && _vm.videoLoaded }
              },
              [
                _c("img", {
                  staticClass: "hidden-mobile-down",
                  attrs: {
                    src: require("../../assets/運勢書共用/Desktop-Loading.png"),
                    alt: "loading-desktop"
                  },
                  on: {
                    load: function($event) {
                      return _vm.initAnimation()
                    }
                  }
                }),
                _c("img", {
                  staticClass: "hidden-mobile-up",
                  attrs: {
                    src: require("../../assets/運勢書共用/Mobile-Loading.png"),
                    alt: "loading-mobile"
                  }
                })
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "book__main__quote" }, [
      _c("div", { staticClass: "book__main__quote__title" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/運勢書共用/2024.svg"),
            alt: "解答之書-裝飾圖片1"
          }
        }),
        _c("br"),
        _vm._v("会是怎么样的一年\n      ")
      ]),
      _c("div", { staticClass: "book__main__quote__content" }, [
        _vm._v(
          "\n        2024年，冥王用「最后八个月」帮我们暖身，给出胆量让我们尝试。"
        ),
        _c("span", [_vm._v("动作够快、懂抓住机会的人")]),
        _vm._v("，就有高机率能异军崛起，甚至撼动未来二十年生涯。"),
        _c("br"),
        _c("br"),
        _vm._v(
          "2024年四月前，也是木天合高峰，我们即将充分感受天王星能量。阶级颠覆、规则打破、新生代出头，各种创意蓬发"
        ),
        _c("br"),
        _c("br"),
        _vm._v("面对新世界，我们不能再用旧的自己迎接"),
        _c("br"),
        _c("span", [_vm._v("需打破习性")]),
        _vm._v("，新的价值观，新的表达方式面对"),
        _c("br"),
        _c("br"),
        _vm._v("你已跃跃欲试了吗？记得喔，改变的意义不在「马上成功」，"),
        _c("span", [_vm._v("改变是为了给自己一个新的机会")]),
        _vm._v("，现在起，开始改变，你已拿到进入新世界的门票，加油喔！\n      ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "book__main__constellations__title" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/運勢書共用/探索星座.svg"),
          alt: "解答之書-探索星座"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }